module.exports = __webpack_public_path__ + "img/Slice4-min.e7b85c97.png";